import { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import { SearchLocation } from 'modules/search/types/SearchLocation';
import { SearchSortType } from 'modules/search/types/SearchSortType';
import { AlgoliaSearchOptionsWithIndex } from 'utils/algolia/types/AlgoliaSearchOptionsWithIndex';

import { searchAlgoliaEventsOptions } from './searchAlgoliaEventsOptions';
import { searchAlgoliaInternshipsOptions } from './searchAlgoliaInternshipsOptions';
import { searchAlgoliaJobsOptions } from './searchAlgoliaJobsOptions';
import { searchAlgoliaOrgsOptions } from './searchAlgoliaOrgsOptions';
import { searchAlgoliaVolopsOptions } from './searchAlgoliaVolopsOptions';

type Args = {
  filtersById: SearchFiltersById;
  sort: SearchSortType;
  searchLocation: SearchLocation | undefined;
};

export function searchAlgoliaOptionsSwitch({
  filtersById,
  sort,
  searchLocation,
}: Args): AlgoliaSearchOptionsWithIndex {
  switch (filtersById.type) {
    case 'JOB':
      return searchAlgoliaJobsOptions({ filtersById, sort, searchLocation });
    case 'VOLOP':
      return searchAlgoliaVolopsOptions({ filtersById, sort, searchLocation });
    case 'EVENT':
      return searchAlgoliaEventsOptions({ filtersById, sort, searchLocation });
    case 'INTERNSHIP':
      return searchAlgoliaInternshipsOptions({
        filtersById,
        sort,
        searchLocation,
      });
    case 'ORG':
      return searchAlgoliaOrgsOptions({ filtersById, sort, searchLocation });
  }
}
